import { Component, OnInit } from '@angular/core';

import {
  DashboardService,
  RelationshipCount,
} from '../../../services/dashboard/dashboard.service';
import { UserService } from '../../../services/user/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit {
  relationshipcount: RelationshipCount;
  isAdmin: boolean = false;

  constructor(
    public dashboardsrc: DashboardService,
    user: UserService,
  ) {
    user.isAdmin.subscribe(value => {
      this.isAdmin = value;
    });
  }

  ngOnInit() {
    this.dashboardsrc.getRelationshipCount().then(data => {
      this.relationshipcount = data;
    });
  }
}
